export default __webpack_public_path__ + "static/media/painscale_6.01dbdd2c.png";